import Axios from "axios";
import store from "redux/Store";

export default (q) =>
  new Promise(function (resolve, reject) {
    const {
      user: {
        credentials: { orgID },
      },
    } = store.getState();

    Axios
    .post(`${orgID}/playout/getAllRadioChannels`)
    .then((res) => {
        resolve( res.data.results)
    })
    .catch((err) => {
      resolve([]);
      });
  });
